import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faClipboard } from "@fortawesome/free-regular-svg-icons/faClipboard";
import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "../utils/local-antd";
import type { TooltipProps } from "../utils/local-antd";

import { ThemeType } from "../theme/Theme";
import { AtiraToast } from "../utils/AtiraToast";
import { AtiraIcon } from "./AtiraIcon";
import { Button } from "./Button";

type CopyButtonProps = {
  copy: string;
  tooltipText?: string;
  icon?: IconProp;
  iconColor?: keyof ThemeType;
  iconSize?: SizeProp;
  asText?: boolean;
  className?: string;
} & Partial<TooltipProps>;

export const CopyButton: React.FC<CopyButtonProps> = ({
  copy,
  tooltipText,
  icon,
  iconColor = "darkerSub",
  asText = false,
  iconSize = "xl",
  className,
  ...props
}) => {
  const { t } = useTranslation();

  const onCopy = () => {
    navigator.clipboard.writeText(copy);
    AtiraToast.success(t("common.copy.success"));
  };

  if (asText) {
    return (
      <Button onClick={onCopy} margin="none" hover className={className}>
        {t("common.copy")}
      </Button>
    );
  }

  return (
    <Tooltip title={tooltipText || t("common.copy")} {...props}>
      <Button
        onClick={onCopy}
        backgroundColor="transparent"
        margin="none"
        padding="none"
        className={className}
      >
        <AtiraIcon
          color={iconColor}
          size={iconSize}
          icon={icon || faClipboard}
        />
      </Button>
    </Tooltip>
  );
};
